import React from "react";
import copy from "copy-to-clipboard";
import constants, {
  FACEBOOK,
  TWITTER,
  COPY_ICON,
  LINKEDIN,
} from "../../../constants";
import { toast } from "react-toastify";

import Modals from "../popupModal/modal";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

const SocialShareModal = ({ isOpen, closeModal }) => {
  let webUrl = process.env.REACT_APP_URL;

  const copyToClipboard = () => {
    copy(webUrl);
    toast.success("Text copied successfully", {
      position: constants.TOAST_POSITION,
    });
  };

  return (
    <Modals
      isOpen={isOpen}
      onRequestClose={() => closeModal}
      title="Share Via"
      styles={{
        content: {
          maxWidth: "800px",
        },
      }}
    >
      <React.Fragment>
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <div style={{ margin: "63px 45px 0px 45px" }}>
          <LinkedinShareButton
            url={webUrl}
            className="shareClassSpecial"
            title="Share about UrgiDoctor"
          >
            <img src={LINKEDIN} alt=""></img>
            <div className="shareText">Linkedin</div>
          </LinkedinShareButton>
          <TwitterShareButton
            className="shareClass"
            url={webUrl}
            title="Share about UrgiDoctor"
          >
            <img src={TWITTER} alt=""></img>
            <div className="shareText">Twitter</div>
          </TwitterShareButton>
          <FacebookShareButton
            className="shareClass"
            url={webUrl}
            title="Share about UrgiDoctor"
          >
            <img src={FACEBOOK} alt=""></img>
            <div className="shareText">Facebook</div>
          </FacebookShareButton>
          <WhatsappShareButton
            title="Share about UrgiDoctor"
            className="shareClass"
            url={webUrl}
            disabled={true}
            disabledStyle={{ opacity: "1" }}
          >
            <img onClick={copyToClipboard} src={COPY_ICON} alt=""></img>
            <div className="shareText">Copy Link</div>
          </WhatsappShareButton>
        </div>
      </React.Fragment>
    </Modals>
  );
};

export default SocialShareModal;
